module.exports = __webpack_public_path__ + "img/login-ciudadelaejercito.7851b37a.svg";